export const FETCH_PHONES_START = "FETCH_PHONES_START";
export const FETCH_PHONES_SUCCESS = "FETCH_PHONES_SUCCESS";
export const FETCH_PHONES_FAILURE = "FETCH_PHONES_FAILURE";

export const LOAD_MORE_PHONES_START = "LOAD_MORE_PHONES_START";
export const LOAD_MORE_PHONES_SUCCESS = "LOAD_MORE_PHONES_SUCCESS";
export const LOAD_MORE_PHONES_FAILURE = "LOAD_MORE_PHONES_FAILURE";

export const FETCH_PHONE_BY_ID_START = "FETCH_PHONE_BY_ID_START";
export const FETCH_PHONE_BY_ID_SUCCESS = "FETCH_PHONE_BY_ID_SUCCESS";
export const FETCH_PHONE_BY_ID_FAILURE = "FETCH_PHONE_BY_ID_FAILURE";

export const ADD_PHONE_TO_BASKET = "ADD_PHONE_TO_BASKET";

export const SEARCH_PHONE = "SEARCH_PHONE";

export const FETCH_CATEGORIES_START = "FETCH_CATEGORIES_START";
export const FETCH_CATEGORIES_SUCCESS = "FETCH_CATEGORIES_SUCCESS";
export const FETCH_CATEGORIES_FAILURE = "FETCH_CATEGORIES_FAILURE";

export const REMOVE_PHONE_FROM_BASKET = "REMOVE_PHONE_FROM_BASKET";

export const CLEAN_BASKET = "CLEAN_BASKET";



// WEBPACK FOOTER //
// ./src/~/actionTypes.js